import type whatsappEn from "./whatsapp.en";

const whatsappAr: Record<keyof typeof whatsappEn, string> = {
  "wa.title": "واتساب",
  "wa.description": "أرسل تحديثات الطلبات وتأكيدات الدفع عند الاستلام والتنبيهات عبر واتساب من رقم نشاطك التجاري، إضافة إلى البريد.",
  "wa.enabled": "إرسال رسائل واتساب",
  "wa.not_connected": "اربط رقم واتساب للأعمال لمراسلة العملاء الذين يُدخلون رقم هاتف عند الدفع.",
  "wa.connect": "ربط واتساب",
  "wa.connect_title": "ربط رقم واتساب للأعمال",
  "wa.update": "تحديث البيانات",
  "wa.paused": "رسائل واتساب متوقفة. يستلم العملاء البريد فقط.",
  "wa.number": "الرقم",
  "wa.verified_name": "الاسم الظاهر",
  "wa.webhook_title": "تحديثات التسليم",
  "wa.webhook_hint": "في تطبيق Meta افتح WhatsApp › Configuration، والصق هذه القيم في Webhook، واشترك في حقل \"messages\". هكذا تعرف متى سُلّمت الرسائل وقُرئت.",
  "wa.callback_url": "رابط الاستدعاء",
  "wa.verify_token": "رمز التحقق",
  "wa.templates": "قوالب الرسائل",
  "wa.templates_hint": "لا يوصل واتساب الرسائل التي يبدأها النشاط التجاري إلا بقوالب توافق عليها Meta. أرسل قوالبنا إلى حسابك؛ تستغرق الموافقة عادة دقائق وأحياناً حتى 24 ساعة. حتى تتم الموافقة تُرسل الرسالة بالبريد فقط.",
  "wa.submit": "إرسال إلى Meta",
  "wa.refresh": "تحديث الحالة",
  "wa.submitted": "أُرسلت القوالب إلى Meta للمراجعة.",
  "wa.synced": "تم تحديث حالة القوالب.",
  "wa.marketing": "تسويقية",
  "wa.test": "إرسال تجربة",
  "wa.send": "إرسال",
  "wa.test_to": "إرسال إلى",
  "wa.test_hint": "يرسل نموذج Meta \"hello world\". يجب أن يستقبل الرقم رسائل واتساب.",
  "wa.test_sent": "أُرسلت رسالة التجربة.",
  "wa.disconnect": "فصل",
  "wa.disconnect_title": "فصل واتساب؟",
  "wa.disconnect_body": "سيستلم العملاء البريد فقط. يبقى رقمك في حساب Meta.",
  "wa.disconnected": "تم فصل واتساب.",
  "wa.connected": "تم ربط واتساب.",
  "wa.step1": "في Meta Business Suite افتح WhatsApp Manager وأضف رقم هاتف نشاطك (أو استخدم رقمك الحالي).",
  "wa.step2": "في developers.facebook.com أنشئ تطبيقاً من نوع Business وأضف منتج WhatsApp مرتبطاً بحساب واتساب للأعمال.",
  "wa.step3": "في إعدادات الأعمال › مستخدمو النظام، أضف مستخدم نظام بصلاحية مدير، وامنحه التطبيق وحساب واتساب، وأنشئ رمزاً لا ينتهي بصلاحيتي whatsapp_business_messaging وwhatsapp_business_management.",
  "wa.step4": "في التطبيق WhatsApp › API setup انسخ Phone number ID ومعرّف حساب واتساب للأعمال.",
  "wa.step5": "في التطبيق Settings › Basic انسخ App secret.",
  "wa.step6": "الصقها أدناه. بعد الربط اضبط تحديثات التسليم وأرسل قوالب الرسائل.",
  "wa.phone_number_id": "معرّف رقم الهاتف",
  "wa.waba_id": "معرّف حساب واتساب للأعمال",
  "wa.access_token": "رمز الوصول",
  "wa.access_token_hint": "الرمز الدائم لمستخدم النظام. يُحفظ مشفراً.",
  "wa.app_secret": "سر التطبيق",
  "wa.app_secret_hint": "يتحقق من أن تحديثات التسليم من Meta فعلاً. يُحفظ مشفراً.",
  "wa.keep_secret": "اتركه فارغاً للإبقاء على المحفوظ.",
  "wa.st.approved": "معتمد",
  "wa.st.pending": "قيد المراجعة",
  "wa.st.rejected": "مرفوض",
  "wa.st.error": "خطأ",
  "wa.st.none": "لم يُرسل",
  "wa.st.paused": "موقوف",
  "wa.st.disabled": "معطّل",
  "wa.type.order_confirmation": "تأكيد الطلب",
  "wa.type.cod_confirmation": "تأكيد الدفع عند الاستلام",
  "wa.type.shipping_confirmation": "شحن الطلب",
  "wa.type.out_for_delivery": "خرج للتوصيل",
  "wa.type.delivered": "تم التوصيل",
  "wa.type.ready_for_pickup": "جاهز للاستلام",
  "wa.type.order_cancelled": "إلغاء الطلب",
  "wa.type.refund_notification": "الاسترداد",
  "wa.type.back_in_stock": "عودة المنتج",
  "wa.type.abandoned_checkout": "تذكير السلة المتروكة",
  "notif.status.read": "مقروءة",
};

export default whatsappAr;
